import React, { Component, PropTypes } from 'react';
import FileSelectorContainer from 'components/Widgets/FileSelectorContainer';
import Overlay from 'components/Overlay';
import { Styles, Paper } from 'material-ui';

const { Spacing } = Styles;

const styles = {
  root: {
    position: 'fixed',
    left: Spacing.desktopGutter * 2,
    right: Spacing.desktopGutter * 2,
    top: Spacing.desktopGutter * 2,
    bottom: Spacing.desktopGutter * 2
  }
};

export default class FileSelectorDialog extends Component {
  static displayName = 'FileSelectorDialog';

  render() {
    const { onOpen, onClose, open, ...other } = this.props;
    return (
      <Overlay ref="overlay" onOpen={onOpen} onClose={onClose} open={open}>
        <Paper rounded style={styles.root}>
          <FileSelectorContainer {...other} />
        </Paper>
      </Overlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/FileSelectorDialog.js